import BaseService from "@client.services/baseService";

export default class AuthService extends BaseService {
  constructor() {
    super("auth", true);
  }

  async login(email, token, isGoogle) {
    return super.api(`login`, {
      email,
      token,
      isGoogle,
    });
  }

  async logout() {
    return super.post(`logout`);
  }

  async getProfile() {
    return super.api(`profile`);
  }

  async demoLogin() {
    return super.api(`demo`);
  }
}
